import { render } from "./BrandingDetails.vue?vue&type=template&id=652ace30"
import script from "./BrandingDetails.vue?vue&type=script&lang=js"
export * from "./BrandingDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Event/Create/BrandingDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "652ace30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('652ace30', __exports__)) {
    console.log('reload')
    api.reload('652ace30', __exports__)
  }
  
  module.hot.accept("./BrandingDetails.vue?vue&type=template&id=652ace30", () => {
    console.log('re-render')
    api.rerender('652ace30', render)
  })

}


export default __exports__